import SweetAlert from 'sweetalert2';
import withReactContext from 'sweetalert2-react-content';
import 'sweetalert2/dist/sweetalert2.css';
import { buildPage } from './components/portal/Page';

const defaultOptions = {
	showCancelButton: true,
	icon: 'warning'
};

const HTML = ['title', 'html', 'iconHtml', 'footer', 'closeButtonHtml', 'loaderHtml'];

const Prompt = withReactContext(SweetAlert);

export function fire(prompt) {
	const props = { ...defaultOptions, ...prompt };
	HTML.forEach(prop => {
		if(typeof props[prop] === 'object') {
			props[prop] = buildPage(props[prop]);
		}
	});
	return Prompt.fire(props);
}

export default Prompt;
